import React, { useEffect } from "react";

const ImprimirPdf = ({ pdfBase64, onAfterPrint }) => {

  useEffect(() => {
    if (pdfBase64) {
      handlePrint();
    }
  }, [pdfBase64]);

  const handlePrint = () => {
    if (pdfBase64) {
      const byteCharacters = atob(pdfBase64.split(',')[1] || pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      
      const printWindow = window.open(url, '_blank');
      
      if (printWindow) {
        printWindow.print();
      }
      
      setTimeout(() => {
        URL.revokeObjectURL(url);
        if (onAfterPrint) onAfterPrint();
      }, 1000);
    }
  };

  return null;
};

export default ImprimirPdf;
